<template>
  <img :src="'/img/lang/' + locale + '.svg'" class="locale-flag" :style="'height:' + height" :alt="locale" />
</template>

<script>
export default {
  props: {
    locale: { type: String, default: 'de_DE' },
    height: { type: String, default: '1rem' },
  },
};
</script>
